<!--
 * @Author: xcy
 * @Date: 2021-04-13 15:48:52
 * @LastEditTime: 2022-01-19 15:34:48
 * @LastEditors: xcy
 * @Description: 
-->
<template>
  <div id="app">
  
    <router-view />
  </div>
</template>

<script>
export default {
  created(){
    console.log("v1.0.2-20210826-1-UAT")
  },
  methods: {
    onClickBack() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
.title {
  margin-bottom: 48px;
  font-size: 36px;
  padding-left: 16px;
  border-left: 8px solid #26907a;
}
</style>
